import type { CheckoutLineItemResponse, CheckoutResponse } from '../api/checkout';

export function checkoutPrimaryLine(checkout: CheckoutResponse): CheckoutLineItemResponse | null {
  return checkout.lineItems[0] ?? null;
}

export function checkoutLineLabel(line: CheckoutLineItemResponse): string {
  const name = line.productSnapshot.name ?? 'Item';
  return line.quantity > 1 ? `${name} × ${line.quantity}` : name;
}
